import { render, staticRenderFns } from "./IconBetaReports.vue?vue&type=template&id=267a0950&"
import script from "./IconBetaReports.vue?vue&type=script&lang=ts&"
export * from "./IconBetaReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports